import React from "react";
import knightImage from "../assets/img/pooknightimage.png";
import tltbImage from "../assets/img/tolearnthebasics.png";
import complexfpsImage from "../assets/img/complexfps.png";
import casinoImage from "../assets/img/casino404.png"
import { useLanguage } from "../context/LanguageContext";

export const Projects = () => {

    const { t } = useLanguage();

    const projects = [
        {
            name: "CASINO 404",
            description: t.projects.casino404,
            image: casinoImage,
        },
        {
            name: "TO LEARN THE BASICS",
            description: t.projects.tltb,
            image: tltbImage,
        },
        {
            name: "COMPLEX FPS",
            description: t.projects.complexfps,
            image: complexfpsImage,
        },
        {
            name: "POO KNIGHT",
            description: t.projects.pooKnight,
            image: knightImage,
        }

    ];

    return (
        <div className="projects" id="projects">

            <h1>{t.projects.projectsTitle}</h1>

            <div className="projects-container">
                {projects.map((project, index) => (
                    <div key={index} className="project-card">
                        <div className="project-info">
                            <h2>{project.name}</h2>
                            <p dangerouslySetInnerHTML={{ __html: project.description }} />
                        </div>
                        <div className="project-image">
                            <img src={project.image} alt={project.name} />
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};